import React from "react";
import "./flip.css"; // animations CSS

export default function FlipUnit({ value }) {
  return (
    <div className="flip-unit">
      <span className="flip-card">{String(value).padStart(2, "0")}</span>
    </div>
  );
}
